import { validatePhoneNumberLength } from 'libphonenumber-js';
import { DEFAULT_LANGUAGE } from 'constants/language';
import hasNorwegianPrefix from './hasNorwegianPrefix';
import isEmptyNumber from './isEmptyNumber';
const getPhoneErrorInternal = (phoneNr, t) => {
  if (isEmptyNumber(phoneNr)) return t('error.number.empty');
  if (hasNorwegianPrefix(phoneNr)) {
    if (phoneNr.length < 11) return t('error.number.TOO_SHORT');
    if (phoneNr.length > 11) return t('error.number.TOO_LONG');
    if (['0', '1'].includes(phoneNr[3])) return t('error.number.wrong_prefix');
  }
  const lengthResult = validatePhoneNumberLength(phoneNr, DEFAULT_LANGUAGE);
  if (lengthResult) {
    return t(`error.number.${lengthResult}`);
  }
  return '';
};
export default (phoneNr, t) => {
  const error = getPhoneErrorInternal(phoneNr, t);
  return error && `${t('error.number.general')}: ${error}`;
};